import styled from "styled-components";

export const MobileAccountBoxEquityStyled = styled.div`
    font-weight: 600;
    font-size: 32px;
    font-style: normal;
    color: var(--color-label-primary);

    .currency {
        color: var(--color-label-tertiary);
    }

    .afterDot {
        font-size: 24px;
    }
`;